module.exports = __webpack_public_path__ + "img/favouritePiece.55fb4d2.webp";